import React, { useCallback } from 'react';
import { CalendarList, DateData } from 'react-native-calendars';
import moment from 'moment';
import {
  HStack,
  Icon,
  Icons,
  Modal,
  ModalBackdrop,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  Text,
  View,
  VStack,
} from '@tonic/central-specialties-ui-themed';
import { CustomDay } from './EntityCardExplorer/DateSelect/CustomDay';

interface ReactivationDatePickerModalProps {
  visible: boolean;
  onClose: () => void;
  onDateSelect: (date: string) => void;
}

const minDate = '2024-04-01';

const ReactivationDatePickerModal: React.FC<
  ReactivationDatePickerModalProps
> = ({ visible, onClose, onDateSelect }) => {
  const today = moment();

  const pastScrollRange = today.isAfter(moment(minDate))
    ? today.diff(moment(minDate), 'months')
    : 0;

  const handleDayPress = useCallback(
    (day: DateData) => {
      if (moment(day.dateString).isAfter(today, 'day')) {
        return;
      }
      onDateSelect(day.dateString);
      onClose();
    },
    [onClose, onDateSelect, today],
  );

  return (
    <Modal isOpen={visible} onClose={onClose}>
      <ModalBackdrop bg="$gray700" />
      <ModalContent
        borderRadius={0}
        maxHeight="80%"
        w="$96"
        width="60%"
        maxWidth={840}
        minWidth={480}
      >
        <ModalHeader
          bg="$primary700"
          alignItems="center"
          justifyContent="space-between"
          py="$2"
          pl="$10"
          pr="$6"
        >
          <Text color="$white" size="lg">
            Select Reactivation Date
          </Text>
          <ModalCloseButton w="$8" justifyContent="center" alignItems="center">
            <Icon color="$white" size="xl" as={Icons.X} />
          </ModalCloseButton>
        </ModalHeader>
        <ModalBody w="$full">
          <VStack>
            <HStack
              justifyContent="space-around"
              paddingVertical={'$2'}
              maxWidth={800}
            >
              {['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'].map((day) => (
                <View alignItems="center" key={day}>
                  <Text fontWeight="bold" color="$textDark700">
                    {day}
                  </Text>
                </View>
              ))}
            </HStack>
            <CalendarList
              current={today.format('YYYY-MM-DD')}
              pastScrollRange={pastScrollRange}
              futureScrollRange={0}
              maxDate={today.format('YYYY-MM-DD')}
              hideDayNames
              scrollEnabled
              showScrollIndicator={true}
              monthFormat="MMM yyyy"
              onDayPress={handleDayPress}
              theme={{
                calendarBackground: '#F8F8F8',
                textSectionTitleColor: '#000',
                dayTextColor: '#000',
                todayTextColor: '#000',
                selectedDayBackgroundColor: '#FFDADA',
                selectedDayTextColor: '#9D0101',
                textDayFontWeight: 'bold',
              }}
              style={{ height: 400, maxWidth: 840 }}
              calendarWidth={800}
              dayComponent={(props) => (
                <CustomDay
                  {...props}
                  onDayPress={handleDayPress}
                  allowFutureSelection={false}
                />
              )}
            />
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ReactivationDatePickerModal;
